import React from 'react';
import UserDashboardJob from 'components/UserDashboard/UserDashboardJob/UserDashboardJob';

const UserDashboardJobDetails = () => <UserDashboardJob />;

export default UserDashboardJobDetails;
